import { createTheme } from "@mui/material";
import { breakpoints } from "./breakpoints.js";
import { capitalDesignTokens } from "@opengov/capital-design-tokens";
import { capitalDesignTokens as capitalDesignTokens2 } from "@opengov/capital-design-tokens";
import { components } from "./components/index.js";
import { darkPalette } from "./darkPalette.js";
import { lightPalette } from "./lightPalette.js";
import { shape } from "./shape.js";
import { getTypography } from "./typography.js";
function convertTokensToMuiTheme(tokens, mode) {
  return createTheme({
    palette: mode === "light" ? lightPalette : darkPalette,
    typography: getTypography,
    components,
    breakpoints,
    shape,
    ...tokens
  });
}
const capitalMuiTheme = convertTokensToMuiTheme(capitalDesignTokens, "light");
const capitalMuiDarkTheme = convertTokensToMuiTheme(capitalDesignTokens, "dark");
export {
  capitalDesignTokens2 as capitalDesignTokens,
  capitalMuiDarkTheme,
  capitalMuiTheme,
  convertTokensToMuiTheme
};
//# sourceMappingURL=index.js.map
